<template>
    <!-- TODO - EPIC-1000 EPIC : Soap migration -->
    <b-row class="soap-details">
        <b-col xl="4" md="4" sm="4">
            <b-table-simple borderless>
                <b-tbody>
                    <patient-edit
                        ref="patientEdit"
                        @edit-status="afterEditStatusPatient"
                        @edit-saved="cancelSave"
                        :isFromSoap="true"
                        :patient="soap.patient"
                    />
                </b-tbody>
            </b-table-simple>
        </b-col>
        <b-col xl="4" md="4" sm="4">
            <b-table-simple borderless>
                <b-tbody>
                    <b-form-group
                        label-cols="3"
                        label="Title:"
                        label-for="title"
                    >
                        <b-input
                            v-model="title"
                            placeholder="Name (required)"
                            v-validate="''"
                            name="title"
                            class="form-control"
                            :class="{
                                'border-danger': formError.includes('title')
                            }"
                        />
                    </b-form-group>
                    <b-form-group
                        label-cols="3"
                        label="Date:"
                        label-for="soapDate"
                    >
                        <date-picker
                            :config="{
                                useCurrent: false
                            }"
                            v-model="soapDate"
                            name="soapDate"
                            :placeholder="getDateFormat() + ' (required)'"
                            :class="{
                                'border-danger': formError.includes('soapDate')
                            }"
                        />
                        <b-form-checkbox
                            id="update_related_medical_record_dates"
                            name="update_related_medical_record_dates"
                            class="mt-1 pe-auto"
                            v-model="changeRelatedRecordDate"
                        >
                            <span class="font-weight-normal"
                                >Update related medical record dates</span
                            >
                        </b-form-checkbox>
                    </b-form-group>
                    <b-form-group
                        label-cols="3"
                        label="Status:"
                        label-for="status"
                    >
                        <b-input
                            :value="assignedStatus(soap.status)"
                            plaintext
                        />
                    </b-form-group>
                    <b-form-group
                        label-cols="3"
                        label="Complaint:"
                        label-for="complaint"
                    >
                        <b-input
                            v-model="complaint"
                            name="complaint"
                            placeholder="Complaint (optional)"
                            class="form-control"
                            v-validate="''"
                        />
                    </b-form-group>
                    <b-form-group
                        label-cols="3"
                        label="Provider:"
                        label-for="provider"
                    >
                        <v-select
                            id="provider"
                            v-model="provider"
                            placeholder="Provider (optional)"
                            name="provider"
                            :options="providerOptions"
                            item-text="label"
                        />
                    </b-form-group>
                    <b-form-group
                        label-cols="3"
                        label="Referred By:"
                        label-for="referredBy"
                    >
                        <vet-select
                            module="referrer"
                            v-model="referredBy"
                            placeholder="Select referral Source (optional)"
                        />
                    </b-form-group>
                    <b-form-group
                        label-cols="3"
                        label="Last Updated:"
                        label-for="lastUpdated"
                    >
                        <b-input
                            :value="lastUpdateLabel(soap.update_at)"
                            plaintext
                        />
                    </b-form-group>
                    <b-form-group
                        label-cols="3"
                        label="Updated By:"
                        label-for="updatedBy"
                    >
                        <b-input
                            :value="updateByLabel(soap.last_audit_by)"
                            plaintext
                        />
                    </b-form-group>
                    <b-form-group
                        label-cols="3"
                        label="Billing:"
                        label-for="billing"
                    >
                        <template v-if="soap.invoices">
                            <div
                                v-for="invEst in soap.invoices"
                                :key="invEst.id"
                                class="pt-2 pl-1"
                            >
                                <estimate-link
                                    v-if="invEst.is_estimate"
                                    :estimate="invEst"
                                />
                                <invoice-link
                                    v-else
                                    :invoice="invEst"
                                    :newTab="false"
                                />
                                ({{ invEst.total_amount }})
                            </div>
                        </template>
                    </b-form-group>
                </b-tbody>
            </b-table-simple>
        </b-col>
        <b-col xl="4" md="4" sm="4" v-if="reminders.length > 0">
            <patient-reminder ref="patientReminder" :reminders="reminders" />
        </b-col>
        <assign-provider-modal
            ref="assignProviderModal"
            @save="proceedSaveAll"
            @cancel="cancelSave"
        />
    </b-row>
</template>
<script>
/**
 * @name SoapDisplayEdit
 * @see apps/application/views/staff/patient/soap/create_update_profile.php
 */
import { isEmpty, find } from "lodash";
import PatientSoapService from "@/services/patient/patient-soap";
import Staff from "@/services/staff";
const LOCKED = 1;

export default {
    mixins: [],
    components: {
        PatientEdit: () => import("@/components/patient/patient-edit"),
        VetSelect: () => import("@/module/commons/vet-select"),
        VSelect: () => import("vue-select"),
        PatientReminder: () =>
            import("@/components/patient/sub/patient-reminder"),
        InvoiceLink: () => import("@/components/commons/invoice-link"),
        EstimateLink: () => import("@/components/commons/estimate-link"),
        AssignProviderModal: () =>
            import("@/components/soap/assign-provider-modal")
    },
    props: {
        soap: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            formError: [],
            title: "",
            soapDate: "",
            changeRelatedRecordDate: false,
            complaint: this.soap.complaint || "",
            provider: null,
            providerOptions: [],
            referredBy: null,
            refferedById: null,
            patientStatusDataModal: {}, // The data from modal-edit-status,
            reassign: false
        };
    },
    beforeMount() {},
    mounted() {
        this.setSoapTitle();
        this.setSoapDate();
        this.getStaffList();
        this.setReferredBy();
    },
    computed: {
        reminders() {
            return this.$store.getters["patient/reminders"];
        }
    },
    watch: {
        title(value) {
            if (!isEmpty(value)) {
                this.clearError("title");
            }
        },
        soapDate(value) {
            if (!isEmpty(value)) {
                this.clearError("soapDate");
            }
        }
    },
    methods: {
        setSoapTitle() {
            this.title = this.soap.title || this.soap.name_only;
        },
        setSoapDate() {
            const { date } = this.soap;
            let result = "";

            if (date) {
                result = this._carbonDateDisplay(date);
            }
            this.soapDate = result;
        },
        clearError(key) {
            this.formError = this.formError.filter(err => err !== key);
        },
        assignedStatus(status) {
            if (status == LOCKED) {
                return `Locked (${this._carbonDateDisplay(
                    this.soap.update_at
                )})`;
            } else {
                return "In Process";
            }
        },
        lastUpdateLabel(date) {
            if (date) {
                return this._carbonDateDisplay(date);
            }
            return "";
        },
        updateByLabel(updateBy) {
            if (updateBy && updateBy.label) {
                return updateBy.label;
            }
            return "";
        },
        getStaffList() {
            let self = this;

            let currentProvider = null;
            if (this.soap.prescribed_by) {
                currentProvider = this.soap.prescribed_by;
            } else if (this.soap.default_provider) {
                currentProvider = {
                    id: this.soap.default_provider.id,
                    label: this.soap.default_provider.display_name
                };
            }

            if (!isEmpty(currentProvider)) {
                self.provider = currentProvider;
            }

            Staff.getProviders().then(response => {
                if (response && response.resource && response.resource.data) {
                    self.providerOptions = self.providerOptions.concat(
                        response.resource.data.map(data => {
                            return data.actor;
                        })
                    );
                }
            });
        },
        async checkFormIsValid() {
            let patientValid = await this.$refs.patientEdit.checkFormValid();

            let valid = await this.$validator.validateAll();
            if (isEmpty(this.title)) {
                this.formError.push("title");
            }

            if (!this.soapDate) {
                this.formError.push("soapDate");
            }

            if (!patientValid || !valid || this.formError.length > 0) {
                return false;
            }

            return true;
        },
        setReferredBy() {
            if (this.soap.soap_referrals && this.soap.referred_by) {
                const referral = this.soap.soap_referrals[0];
                const referralType = this.soap.referred_by.referral_type;

                this.referredBy = {
                    id: referral.referral_id,
                    type: referral.referral_source,
                    label:
                        referralType === "campaign"
                            ? this.soap.referred_by.title
                            : this.soap.referred_by.label
                };
            }
        },
        save() {
            this.$refs.patientEdit.save();
        },
        afterEditStatusPatient(dataModal = {}) {
            this.patientStatusDataModal = dataModal;

            this.checkProviderIsUpdated();
        },
        async proceedSaveAll(dataProviderModal = {}) {
            if (dataProviderModal.reassign) {
                this.reassign = dataProviderModal.reassign;
            }

            const resPatientEdit = await this.$refs.patientEdit.proceedSave(
                this.patientStatusDataModal
            );

            this.$emit("routerview-changeissaving", true);

            if (resPatientEdit) {
                this.proceedSaveSoap();
            } else {
                console.error("Error: Unable to save patient");
                this._message("Error: Unable to save", "danger");
            }
        },
        async proceedSaveSoap() {
            let details = {};
            let generalErrorMsg = "Error: Unable to save";

            try {
                const isSoapSaveSuccess = await this.saveSoapProfile();
                if (isSoapSaveSuccess) {
                    this._message("Record updated");

                    this.$store.commit("patient/setDirty", false);
                    // success
                    this.$emit("edit-saved", {
                        success: true,
                        details: details
                    });

                    this.$emit("routerview-changeissaving", false);
                } else {
                    throw Error(generalErrorMsg);
                }
            } catch (error) {
                console.error("Error: Unable to save soap");
                this._message(generalErrorMsg, "danger");

                this.$emit("edit-saved", {
                    success: false,
                    details: details
                });
            }
        },
        cancelSave() {
            // send signal to 'index.vue'
            this.$emit("edit-saved", {
                success: false
            });

            this.$emit("routerview-changeissaving", false);
        },
        async checkProviderIsUpdated() {
            let prescribedById = null;
            if (this.provider && this.provider) {
                prescribedById = this.provider.id;
            }

            const soapId = this.soap.id;
            const params = {
                prescribed_by: prescribedById || null
            };

            const res = await PatientSoapService.checkProviderIsUpdated(
                soapId,
                params
            );

            if (res.resource && res.message.code === 200) {
                const updateProviderMr = res.resource.update_provider_mr;
                if (updateProviderMr) {
                    this.$refs.assignProviderModal.open();
                } else {
                    this.proceedSaveAll();
                }
            } else {
                throw new Error("Cant find pre-update Soap profile");
            }
        },
        async saveSoapProfile() {
            let details = {};

            let dateFormatted = null;
            if (this.soapDate) {
                dateFormatted = this._fromDateStrToDateTime(
                    this.soapDate,
                    true,
                    true,
                    true
                );
            }

            const patientId = this.soap.patient.id;

            let prescribedById = null;
            if (this.provider && this.provider) {
                prescribedById = this.provider.id;
            }

            details = {
                patient_id: patientId,
                prescribed_by: prescribedById,
                update_provider_mr_val: this.reassign,
                date: dateFormatted,
                change_related_record_date: this.changeRelatedRecordDate,
                title: this.title,
                complaint: this.complaint
            };

            let referrerId = null;
            if (this.referredBy) {
                referrerId = this._bindReferrer(this.referredBy);
                details.referer_id = referrerId;
            } else {
                details.referer_id = null;
            }

            const soapId = this.soap.id;
            const res = await PatientSoapService.saveEditSoapProfile(
                soapId,
                details
            );

            if (res.resource && res.message.code === 200) {
                return true;
            }
            return false;
        }
    }
};
</script>
<style type="text/css" lang="scss" scoped>
.soap-details th,
.soap-details td {
    padding: 0px !important;
    line-height: 35px !important;
}
.soap-details tr {
    padding-left: 1.5rem !important;
}
</style>
